export const WayTypes = [
    [ 'foot', 'OU_FOOT' ],
    [ 'car', 'OU_CAR' ],
    [ 'bus', 'OU_BUS' ],
    [ 'tram', 'OU_TRAM' ],
    [ 'train', 'OU_TRAIN' ],
    [ 'ship', 'OU_SHIP' ],
    [ 'plane', 'OU_PLANE' ],
    [ 'velo', 'OU_VELO' ],
    [ 'horse', 'OU_HRS' ],
    [ 'ski', 'OU_SKI' ],
    [ 'quad', 'OU_QUAD' ],
    [ 'snow', 'OU_SNOW' ]
]
